import { ChangeEvent, useCallback, useState } from "react";

import { globalEvents } from "../../../common/helpers/GlobalEvents";
import { useCartContext } from "../../../contexts/CartServiceContext/CartServiceContext";
import { DINING_TYPE } from "../../constants";
import { CART_PAGE_EVENT } from "../constants";

export const useDineInTakeawayOption = (closeFn: () => void) => {
	const { state: cart } = useCartContext((state) => state);

	const [isTakeaway, setIsTakeaway] = useState<boolean>(cart.is_takeaway);

	const selectTakeaway = useCallback((evt: ChangeEvent<HTMLInputElement>, value: string) => {
		evt.stopPropagation();
		setIsTakeaway(value === DINING_TYPE.TAKEAWAY);
	}, []);

	const confirm = useCallback(() => {
		globalEvents.emit(CART_PAGE_EVENT.CHANGE_DINEIN_TAKEAWAY, isTakeaway);
		closeFn();
	}, [isTakeaway]);

	const cancelConfirm = useCallback(() => {
		closeFn();
	}, []);

	return {
		selectTakeaway,
		confirm,
		cancelConfirm,
		option: isTakeaway ? DINING_TYPE.TAKEAWAY : DINING_TYPE.DINEIN,
	};
};
